import { School, Building2, Briefcase, Handshake, ArrowRight } from "lucide-react";
import AnimatedSection from "@/utils/AnimatedSection";
import { scrollTo } from "@/utils/constants";

const locations = [
  { icon: School, title: "Schools", description: "Annual health screenings integrated into school schedules" },
  { icon: Building2, title: "Residential Communities", description: "Weekend drives at apartments, gated communities, and townships" },
  { icon: Briefcase, title: "Corporate Campuses", description: "Employee family health programs at your workplace" }
];

const ScreeningDrives = () => {
  return (
    <section className="py-24 relative overflow-hidden" data-testid="screening-drives-section">
      <div className="absolute inset-0 bg-gradient-to-br from-[#4ECDC4] via-[#2a9d8f] to-[#1a1a2e]" />
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '32px 32px'
        }} />
      </div>
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-white/10 rounded-full blur-[120px]" />
      <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-[#1a1a2e]/30 rounded-full blur-[100px]" />

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <AnimatedSection>
          <div className="text-center mb-16">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/20 border border-white/20 text-white text-sm font-semibold mb-6 uppercase tracking-wider">
              <Handshake className="w-4 h-4" />
              Community Programs
            </span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight">
              Bringing tots360 to Your Community
            </h2>
            <p className="text-white/80 text-lg md:text-xl leading-relaxed max-w-3xl mx-auto">
              We conduct organized screening drives at schools, residential communities, and corporate campuses — so your child can get assessed without any disruption.
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.2}>
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            {locations.map((loc, i) => (
              <div key={i} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 text-center hover:bg-white/15 transition-all duration-300 group" data-testid={`location-card-${i}`}>
                <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-white/20 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <loc.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="font-display text-xl text-white mb-2">{loc.title}</h3>
                <p className="text-white/70 text-sm leading-relaxed">{loc.description}</p>
              </div>
            ))}
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.3}>
          <div className="flex flex-wrap justify-center gap-4">
            <button onClick={() => scrollTo('contact')} className="group flex items-center gap-2 bg-white text-[#1a1a2e] px-8 py-4 rounded-full font-semibold shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all" data-testid="book-drive-button">
              Book a Screening Drive
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            <button onClick={() => scrollTo('contact')} className="flex items-center gap-2 bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white/10 transition-all" data-testid="partner-button">
              Partner With Us
            </button>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default ScreeningDrives;
